/**
 * =============================================================================
 * RESPONSIVE BREAKPOINT CONSTANTS (P2-20)
 * =============================================================================
 *
 * Centralized breakpoint values for consistent responsive behavior
 * across CSS and JavaScript. Prevents CSS/JS drift.
 *
 * Usage:
 *   import { BREAKPOINTS } from '../constants/breakpoints';
 *   const isMobile = window.innerWidth < BREAKPOINTS.TABLET;
 *
 * =============================================================================
 */

export const BREAKPOINTS = {
  /** Mobile: 0 - 767px */
  MOBILE: 768,
  /** Tablet: 768 - 1023px */
  TABLET: 1024,
  /** Desktop: 1024px+ */
  DESKTOP: 1024,
} as const;

export const MEDIA_QUERIES = {
  MOBILE: `(max-width: ${BREAKPOINTS.MOBILE - 1}px)`,
  TABLET: `(min-width: ${BREAKPOINTS.MOBILE}px) and (max-width: ${BREAKPOINTS.TABLET - 1}px)`,
  DESKTOP: `(min-width: ${BREAKPOINTS.DESKTOP}px)`,
} as const;
